export default __webpack_public_path__ + "870dd6b51ab28e970ba07cc3befefdd6.png";